import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconAlignmentTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { autoTriggerOtp, editDetails, editMobileNumber, editPanNumber, fetchMyPortfolio, goBack, goBackToManageLimit, goHome, modalCloseAction, needHelp, selectSource, } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import { AssetRepositoryTitle, AssetRepositoryType, ConfigTokens, getAppHeader, isDarkModeTheme, } from '../../../configs/config';
import { heightMap } from '../../../configs/height';
import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { CamsFetchErrorHandle, mfcFetchErrorHandle } from './utils';
import { isFromJupiter } from '../../../configs/utils';
import { api } from "../../../configs/api";
const isDarkMode = isDarkModeTheme();
export const template = async (applicationId, panNumber, phoneNumber, emailId, assetRepository, isPanEditAllowed, isRTASwitchEnabled, isGoBackAllowed, isFromManageLimit, isEnhancedLimit, isRTAError, rtaModalBGColor, isFromPhonePe, isFromJupiterPlatform, height, isFromEnhanceLimit, assetRepositoryMap, mfCentralFetchError) => {
    return {
        layout: {
            id: ROUTE.MF_FETCH_PORTFOLIO,
            type: isGoBackAllowed ? LAYOUTS.MODAL : LAYOUTS.LIST,
            style: {
                height: Number(heightMap[ROUTE.MF_FETCH_PORTFOLIO]) <= height - 90 ? heightMap[ROUTE.MF_FETCH_PORTFOLIO] : height - 90,
            },
            widgets: [
                Platform.OS === "android" ? { id: "space0", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
                ...(isGoBackAllowed
                    ? [
                        {
                            id: "headerStack",
                            type: WIDGET.STACK,
                            position: POSITION.ABSOLUTE_TOP,
                            isDarkMode: isDarkMode ? true : false,
                            padding: {
                                right: 8,
                                top: 16,
                                bottom: 0,
                                left: 0,
                            },
                        },
                    ]
                    : isFromManageLimit ? [] : [
                        {
                            id: "customHeader",
                            type: WIDGET.CUSTOM_HEADER,
                            position: POSITION.ABSOLUTE_TOP,
                        }
                    ]),
                ...(isFromManageLimit
                    ? [
                        Platform.OS === "ios" ? {
                            id: "space0",
                            type: WIDGET.SPACE,
                            position: POSITION.ABSOLUTE_TOP
                        } : {},
                        {
                            id: "customHeader",
                            type: WIDGET.CUSTOM_HEADER,
                            position: POSITION.ABSOLUTE_TOP,
                        },
                    ]
                    : []),
                { id: "titleStack", type: WIDGET.STACK },
                { id: "space1", type: WIDGET.SPACE },
                { id: "subTitle", type: WIDGET.TEXT },
                { id: "space2", type: WIDGET.SPACE },
                { id: "panItem", type: WIDGET.LIST_ITEM },
                { id: "divider", type: WIDGET.DIVIDER },
                { id: "mobileItem", type: WIDGET.LIST_ITEM },
                { id: "investmentInfoTooltip", type: WIDGET.MESSAGE },
                { id: "space4", type: WIDGET.SPACE },
                { id: "bottomStack", type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM },
                ...(isRTASwitchEnabled
                    ? [
                        Platform.OS === "ios" ? {} : {
                            id: "space5",
                            type: WIDGET.SPACE,
                            position: POSITION.ABSOLUTE_BOTTOM,
                        },
                        {
                            id: "camsCTAStack",
                            type: WIDGET.STACK,
                            position: POSITION.ABSOLUTE_BOTTOM,
                        },
                    ]
                    : []),
                { id: 'fetchPortfolioModals', type: WIDGET.FETCH_PORTFOLIO_MODAL }
            ],
        },
        datastore: {
            fetchPortfolioModals: {
                visible: isRTAError || mfCentralFetchError !== undefined ? true : false,
                primaryCtaAction: {
                    type: ACTION.EDIT_DETAILS,
                    routeId: ROUTE.MF_FETCH_PORTFOLIO,
                    payload: {}
                },
                tertiaryCTAAction: {
                    type: ACTION.Go_BACK,
                    routeId: ROUTE.MF_FETCH_PORTFOLIO,
                    payload: {}
                },
                onModalCloseAction: {
                    type: ACTION.MODAL_CLOSE,
                    routeId: ROUTE.MF_FETCH_PORTFOLIO,
                    payload: {}
                },
                errorModalBgColor: rtaModalBGColor
            },
            divider: {
                size: DividerSizeTokens.MD,
                color: ColorTokens.Grey_Milk_1
            },
            header: {
                id: 'bt_getPortfolioScreen_goBack',
                isBackButton: true,
                title: "Increase your limit",
                type: HeaderTypeTokens.DEFAULT,
                action: {
                    type: ACTION.GO_BACK_MANAGE_LIMIT,
                    payload: {},
                },
            },
            spaceXXL: {
                size: SizeTypeTokens.XXL
            },
            spaceNew: { size: isGoBackAllowed ? SizeTypeTokens.LG : SizeTypeTokens.XXXL },
            space0: { size: Platform.OS === 'ios' ? SizeTypeTokens.XXXL : SizeTypeTokens.NONE },
            space56: {
                size: SizeTypeTokens.XXXXXXL
            },
            headerStack: {
                type: StackType.row,
                alignItems: StackAlignItems.flexEnd,
                justifyContent: StackJustifyContent.flexEnd,
                widgetItems: [{ id: "leadIcon", type: WIDGET.BUTTON }],
            },
            customHeader: {
                title: "Check limit",
                hideGoBack: isFromJupiterPlatform ? true : false,
                isDarkMode: isDarkMode ? true : false,
                needHelpAction: {
                    routeId: ROUTE.MF_FETCH_PORTFOLIO,
                    type: ACTION.NEED_HELP,
                    payload: { id: 'bt_getPortfolioScreen_needHelp' }
                },
                goBackAction: {
                    routeId: ROUTE.MF_FETCH_PORTFOLIO,
                    type: isFromManageLimit ? ACTION.GO_BACK_MANAGE_LIMIT : ACTION.GO_HOME,
                    payload: { id: 'bt_getPortfolioScreen_goBack' }
                },
                hideNeedHelp: isFromPhonePe,
                hideDivider: false
            },
            leadIcon: {
                id: 'bt_getPortfolioScreen_cancel',
                label: "",
                type: ButtonTypeTokens.SmallGhost,
                width: ButtonWidthTypeToken.CONTENT,
                stack: {
                    type: StackType.row,
                    alignItems: StackAlignItems.flexStart,
                    justifyContent: StackJustifyContent.flexStart,
                },
                labelColor: ColorTokens.Grey_Night,
                icon: {
                    name: IconTokens.Cross,
                    align: IconAlignmentTokens.right,
                    size: IconSizeTokens.XXL,
                },
                action: {
                    type: ACTION.Go_BACK,
                    payload: {},
                    routeId: ROUTE.MF_FETCH_PORTFOLIO,
                },
            },
            titleStack: {
                type: StackType.column,
                padding: {
                    top: SizeTypeTokens.NONE,
                },
                widgetItems: [
                    (isGoBackAllowed || isFromManageLimit) && Platform.OS !== "ios" ? {} : { id: "space0", type: WIDGET.SPACE },
                    { id: "title", type: WIDGET.TEXT }
                ]
            },
            title: {
                label: isEnhancedLimit ? "Fetch updated portfolio" : "Check eligible credit limit",
                fontSize: FontSizeTokens.XL,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: "700",
                numberOfLines: 2,
            },
            bottomStack: {
                type: StackType.column,
                bgColor: isDarkMode ? ColorTokens.DARK_MODE : ColorTokens.White,
                widgetItems: [
                    {
                        id: 'spaceXXL',
                        type: WIDGET.SPACE
                    },
                    {
                        id: "fetchCTA",
                        type: WIDGET.BUTTON,
                    },
                    Platform.OS === "ios" ? { id: "spaceXXL", type: WIDGET.SPACE } : {},
                ]
            },
            subTitle: {
                label: isEnhancedLimit ? "Credit limit is calculated using your mutual " +
                    "fund portfolio" : "Credit limit is calculated using your mutual fund portfolio",
                numberOfLines: 2,
                fontFamily: FontFamilyTokens.Inter,
                color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_Charcoal,
                fontWeight: "400",
                fontSize: FontSizeTokens.SM,
            },
            space1: { size: SizeTypeTokens.SM },
            space2: { size: SizeTypeTokens.XXXL },
            panItem: {
                title: "PAN",
                subTitle: panNumber,
                leadIconName: IconTokens.CreditCard,
                isDarkMode: isDarkMode ? true : false,
                trailIconName: isPanEditAllowed ? IconTokens.Edit : null,
                subTitleLineHeight: 24,
                action: isPanEditAllowed
                    ? {
                        routeId: ROUTE.MF_FETCH_PORTFOLIO,
                        type: ACTION.EDIT_PAN,
                        payload: {
                            applicationId,
                            targetRoute: ROUTE.MF_FETCH_PORTFOLIO,
                            panNumber: panNumber,
                        },
                    }
                    : null,
            },
            mobileItem: {
                id: 'bt_getPortfolioScreen_phoneEdit',
                title: "Mobile number (linked to investments)",
                subTitle: `${phoneNumber}`.substring(3),
                isDarkMode: isDarkMode ? true : false,
                leadIconName: IconTokens.Phone,
                trailIconName: IconTokens.Edit,
                subTitleLineHeight: 24,
                action: {
                    type: ACTION.EDIT_MOBILE_NUMBER,
                    routeId: ROUTE.MF_FETCH_PORTFOLIO,
                    payload: { targetWidgetId: "mobileItem" },
                },
                shouldCardClickable: false
            },
            investmentInfoTooltip: {
                label: "Use mobile number linked to your investments.",
                labelColor: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal,
                bgColor: isDarkMode ? ColorTokens.BACKGROUND_DARK_1 : ColorTokens.Grey_Milk_1,
                icon: {
                    name: IconTokens.Info,
                    size: IconSizeTokens.XL,
                    color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal,
                },
            },
            space4: { size: SizeTypeTokens.XL },
            fetchCTA: {
                id: 'bt_getPortfolioScreen_getPortfolio',
                label: "Get my portfolio",
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.SM,
                width: ButtonWidthTypeToken.FULL,
                type: ButtonTypeTokens.LargeFilled,
                action: {
                    routeId: ROUTE.MF_FETCH_PORTFOLIO,
                    type: ACTION.FETCH_MY_PORTFOLIO,
                    payload: {
                        applicationId,
                        emailId,
                        phoneNumber,
                        panNumber,
                        assetRepository,
                        isRetryAllowed: !isGoBackAllowed
                    },
                },
                loading: false
            },
            space3: { size: SizeTypeTokens.XXL },
            camsCTAStack: {
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.center,
                widgetItems: [
                    { id: "text", type: WIDGET.TEXT },
                    { id: "space", type: WIDGET.SPACE },
                    { id: "assetRepositoryTitle", type: WIDGET.TEXT },
                    { id: "space6", type: WIDGET.SPACE },
                    { id: "editText", type: WIDGET.BUTTON },
                ],
            },
            text: {
                label: "Getting portfolio from",
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Grey_Charcoal,
                fontWeight: "400",
                fontSize: FontSizeTokens.XS,
                lineHeight: 16,
            },
            space: { size: SizeTypeTokens.SM },
            assetRepositoryTitle: {
                label: AssetRepositoryTitle.get(assetRepository).value,
                fontWeight: "600",
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.XS
            },
            space5: { size: SizeTypeTokens.XL },
            editText: {
                id: 'txt_getPortfolioScreen_rtaEdit',
                label: "Edit",
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.SM,
                type: ButtonTypeTokens.MediumGhost,
                paddingHorizontal: SizeTypeTokens.SM,
                paddingVertical: SizeTypeTokens.SM,
                action: {
                    type: ACTION.SELECT_SOURCE,
                    routeId: ROUTE.MF_FETCH_PORTFOLIO,
                    payload: { value: assetRepository, assetRepositoryMap: assetRepositoryMap },
                },
            },
            space6: { size: SizeTypeTokens.MD },
        },
    };
};
export const checkLimitMF = {
    onLoad: async (standardUtilities, { assetRepository, isFromManageLimit, CamsFetchErrorHandleData, }) => {
        await standardUtilities.removeWidgets(ROUTE.MF_FETCH_PORTFOLIO, [
            { id: "fetchPortfolioModals", type: WIDGET.FETCH_PORTFOLIO_MODAL }
        ]);
        const user = await SharedPropsService.getUser();
        const panNumberX = user.linkedBorrowerAccounts[0].accountHolderPAN;
        const phoneNumber = user.linkedBorrowerAccounts[0].accountHolderPhoneNumber;
        const emailId = `${user.linkedBorrowerAccounts[0].accountHolderEmail}`.toLowerCase();
        let applicationId = "";
        if (await AsyncStorage.getItem("application_id") !== null) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            applicationId = user.linkedApplications[0].applicationId;
        }
        const isFromEnhanceLimit = await AsyncStorage.getItem("application_id") !== null;
        standardUtilities.instrumentTrack("CHECK_LIMIT_PAGE_VIEWED", {
            mfCentralEnabled: assetRepository === AssetRepositoryType.MFCENTRAL
        });
        const isPanEditAllowed = await SharedPropsService.getConfig(ConfigTokens.IS_PAN_EDIT_ALLOWED);
        const isRTASwitchEnabled = await SharedPropsService.getConfig(ConfigTokens.IS_RTA_SWITCH_ENABLED);
        const isGoBackAllowed = await SharedPropsService.getConfig(ConfigTokens.IS_MF_FETCH_BACK_ALLOWED);
        const isEnhancedLimit = await AsyncStorage.getItem("application_id") !== null && !(await SharedPropsService.getElevateFlow());
        const isFromPhonePe = await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */;
        const isRTAError = await SharedPropsService.getIsRTAError();
        await standardUtilities.setDatastore(ROUTE.VOLT_APP, "pljJourneyPage", {
            userFullName: user?.linkedBorrowerAccounts[0]?.accountHolderName
        });
        const userPANFullName = user?.linkedBorrowerAccounts[0]?.accountHolderName;
        if (Platform.OS === "web") {
            window.parent.postMessage(`userFullPANName${userPANFullName}`, '*');
        }
        if (isRTAError === true) {
            setTimeout(async () => {
                await CamsFetchErrorHandle(standardUtilities, {
                    response: CamsFetchErrorHandleData?.response,
                    fetchPortfolioPayload: CamsFetchErrorHandleData?.fetchPortfolioPayload,
                    isRetryAllowed: CamsFetchErrorHandleData?.isRetryAllowed
                });
                await SharedPropsService.setIsRTAError(false);
            }, 250);
        }
        const isFromJupiterPlatform = await isFromJupiter();
        const rtaModalBGColor = await SharedPropsService.getRtaModalBGColor();
        const defaultRTAResponse = await standardUtilities.network.get(`${api.getDefaultRTA}${applicationId}`, { headers: await getAppHeader() });
        const mfCentralFetchError = await SharedPropsService.getMFCentralFetchError();
        if (mfCentralFetchError !== undefined) {
            setTimeout(async () => {
                await mfcFetchErrorHandle(standardUtilities, {
                    errorBody: mfCentralFetchError
                });
                await SharedPropsService.setMFCentralFetchError(undefined);
            }, 250);
        }
        const defaultRtaRepository = defaultRTAResponse?.data.find(repo => repo.defaultRta === true);
        const assetRepositoryMap = defaultRTAResponse?.data;
        const finalAssetRepository = assetRepository !== undefined ? assetRepository : defaultRtaRepository?.assetRepository;
        return Promise.resolve(template(applicationId, panNumberX, phoneNumber, emailId, finalAssetRepository, isPanEditAllowed, isRTASwitchEnabled, isGoBackAllowed, isFromManageLimit, isEnhancedLimit, isRTAError, rtaModalBGColor, isFromPhonePe, isFromJupiterPlatform, standardUtilities.getHeight(), isFromEnhanceLimit, assetRepositoryMap, mfCentralFetchError));
    },
    actions: {
        [ACTION.AUTO_FETCH_MY_PORTFOLIO]: autoTriggerOtp,
        [ACTION.FETCH_MY_PORTFOLIO]: fetchMyPortfolio,
        [ACTION.EDIT_PAN]: editPanNumber,
        [ACTION.EDIT_MOBILE_NUMBER]: editMobileNumber,
        [ACTION.Go_BACK]: goBack,
        [ACTION.SELECT_SOURCE]: selectSource,
        [ACTION.GO_BACK_MANAGE_LIMIT]: goBackToManageLimit,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.GO_HOME]: goHome,
        [ACTION.EDIT_DETAILS]: editDetails,
        [ACTION.CONTACT_US]: needHelp,
        [ACTION.MODAL_CLOSE]: modalCloseAction,
    },
    clearPrevious: true,
};
